import React from 'react';
import NavbarAccessRestriction from '@organisms/navbar/navbarAccessRestriction';
import AccessDeniedModal from '@organisms/modals/accessDeniedModal';

const LayoutAccessRestriction = () => {
  return (
    <>
      <NavbarAccessRestriction />
      <AccessDeniedModal />
    </>
  );
};

export default LayoutAccessRestriction;
